import React from "react";

export default function Class4Message(props) {
    return (
        <div className="bg-city-green-light border-t border-b border-city-green-dark/70 text-city-green-dark px-4 py-3">
            <p className="font-bold">{props.address ? `Personal Property: ${props.address}` : `Personal Property`}</p>
            <p className="text-sm">
            Personal Property would not impacted by the Land Value Tax.
            </p>
        </div>
    )
}